export default __webpack_public_path__ + "static/media/FIJ.c3c40f65.svg";